import { connect } from 'react-redux';

import * as PartnerProfile from 'app/entities/PartnerProfile';
import { Profile } from '@zapier/shared-entities';

import NewDev from './NewDev';

import type { PartnerProfileFormValues } from 'app/developer-v3/components/PartnerProfileForm';

const acceptOnboardingInvite = (invitationData: PartnerProfileFormValues) => (
  dispatch,
  getState
) => {
  dispatch(PartnerProfile.actions.acceptOnboardingInvite(invitationData)).then(
    async () => {
      const entity = PartnerProfile.selectors.all.first(getState());
      const id = Profile.selectors.all.currentProfileId(getState());

      if (PartnerProfile.selectors.isFailure(entity)) {
        return;
      }

      await dispatch(Profile.actions.agreeToTermsOfService(id));
      await dispatch(Profile.actions.reloadCurrentProfile());
    }
  );
};

const mapStateToProps = state => {
  const currentProfile = Profile.selectors.all.currentProfile(state);
  const partnerProfile = PartnerProfile.selectors.all.first(state);

  return {
    isLoading: PartnerProfile.selectors.all.isLoading(state),
    isSaving: PartnerProfile.selectors.isSaving(partnerProfile),
    jobTitle: PartnerProfile.selectors.jobTitle(partnerProfile),
    errorMessages: PartnerProfile.selectors.formError(partnerProfile),
    roles: PartnerProfile.selectors.roles(partnerProfile),
    termsAccepted: Profile.selectors.hasAcceptedTerms(currentProfile),
  };
};

const mapDispatchToProps = dispatch => ({
  onLoad() {
    dispatch(PartnerProfile.actions.loadCollection());
  },
  acceptOnboardingInvite(data) {
    dispatch(acceptOnboardingInvite(data));
  },
});

const Container = connect(mapStateToProps, mapDispatchToProps)(NewDev);

export default Container;
